import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    getStreamApiKey: '',
    getStreamToken: '',
    getStreamUserId: '',
    getStreamPatientId: '',
    appointmentStatus: '',
    isCall: true,
};

const getStreamSlice = createSlice({
    name: 'getStreamToken',
    initialState,
    reducers: {
        setGetStreamToken(state, action) {
            state.getStreamApiKey = action.payload.getStreamApiKey;
            state.getStreamToken = action.payload.getStreamToken;
            state.getStreamUserId = action.payload.getStreamUserId;
            state.getStreamPatientId = action.payload.getStreamPatientId;
            state.appointmentStatus = action.payload.appointmentStatus;
            state.isCall = action.payload.isCall;
        },
    },
});

export const {setGetStreamToken} = getStreamSlice.actions; 
export default getStreamSlice.reducer;
